function getScrollBarWidth () {
    var inner = document.createElement('p');
    inner.style.width = "100%";
    inner.style.height = "200px";
    var outer = document.createElement('div');
    outer.style.position = "absolute";
    outer.style.top = "0px";
    outer.style.left = "0px";
    outer.style.visibility = "hidden";
    outer.style.width = "200px";
    outer.style.height = "150px";
    outer.style.overflow = "hidden";
    outer.appendChild (inner);
    document.body.appendChild (outer);
    var w1 = inner.offsetWidth;
    outer.style.overflow = 'scroll';
    var w2 = inner.offsetWidth;
    if (w1 == w2) { w2 = outer.clientWidth; }
    document.body.removeChild (outer);
    return (w1 - w2);
};
(function($){
    // scrollbar corrections
    var scrollbarWidth = getScrollBarWidth();
    $('.hamburger-nav__bg').css('right', scrollbarWidth);
    $('.close, .hamburger-nav__body').on('click', function(e) {
        //$('body').removeClass('hamburger-nav--on').addClass('hamburger-nav--off');
        hamburgerOut();
    });
    $('#header-secondary-menu-toggle, .overlay-menu-trigger').on('click', function(e) {
        e.preventDefault();
        //$('body').removeClass('hamburger-nav--off').addClass('hamburger-nav--on');
        hamburgerIn();
    });
    // prevent menu from closing when clicked, only underlay should close the menu
    $('.hamburger-nav__content').on('click', function(e) {
        e.stopPropagation();
    });
    var width, duration;
    function setInfo() {
        width = $('.hamburger-nav__content').outerWidth();
        duration = width > 600 ? 0.45 : 0.35;
    }
    function hamburgerIn() {
        setInfo();
        $('.hamburger-nav').css('visibility', 'visible');
        $('body').addClass('noscroll').css('padding-right', scrollbarWidth);
        $('.site-header').css('padding-right', scrollbarWidth);
        new TimelineMax()
            .to($('.hamburger-nav__underlay'), 0.3, {opacity: 0.5, ease: Expo.easeNone}, 0)
            .to($('.hamburger-nav__bg'), duration, {marginRight: 0, opacity: 1, ease: Expo.easeOut}, 0.15)
            .to($('.hamburger-nav__content'), duration, {marginRight: 0, opacity: 1, ease: Expo.easeOut}, 0.15)
            .to($('.close', '.hamburger-nav'), 1, {opacity: 1, ease: Expo.easeNone}, duration)
    }
    function hamburgerOut() {
        setInfo();
        new TimelineMax({onComplete: function(){
            $('.hamburger-nav').css('visibility', 'hidden');
            $('body, .site-header').removeClass('noscroll').css('padding-right', '');
        }})
            .to($('.hamburger-nav__underlay'), 0.3, {opacity: 0, ease: Expo.easeNone}, 0.15)
            .to($('.hamburger-nav__bg'), duration, {marginRight: -width, opacity: 0, ease: Expo.easeOut}, 0)
            .to($('.hamburger-nav__content'), duration, {marginRight: -width, opacity: 0, ease: Expo.easeOut}, 0)
            .to($('.close', '.hamburger-nav'), duration, {opacity: 0, ease: Expo.easeNone}, 0)
    }

    //hamburgerIn();
})(jQuery);


/**
 * Add helper css class "[sub-]menu-count-[n]"
 */
(function(){
    document.querySelectorAll('.menu').forEach(function(elem){
        elem.classList.add('menu-count-' + elem.childElementCount);
    });
    document.querySelectorAll('.sub-menu').forEach(function(elem){
        elem.classList.add('sub-menu-count-' + elem.childElementCount);
    });
})();

/**
 * Associate mega menu items.
 */
(function(){
    var navElem = document.querySelector('#primary-menu');
    /**
     * Check sub-menu position/bounds and snap-right or snap-left to the container/row.
     */
    function snapSubmenu() {
        var elems = navElem.querySelectorAll('.menu-item-depth-0 > .sub-menu-container');
        var hInfo = document.querySelector('.site-header__nav').getBoundingClientRect();
        elems.forEach(function(elem){
            var menuItemElem = elem.closest('.menu-item-depth-0');
            menuItemElem.classList.remove('snap-left');
            menuItemElem.classList.remove('snap-right');
            var info = elem.getBoundingClientRect();
            // check right bounds
            if (info.right >= hInfo.right) {
                menuItemElem.classList.add('snap-right');
            }
            // then check left bounds, default to left aligned (over right aligned)
            if (info.left <= hInfo.left) {
                menuItemElem.classList.remove('snap-right');
                menuItemElem.classList.add('snap-left');
            }
        });
    }
    snapSubmenu();
    /**
     * Use snapSubmenu() again if browser window size changes, throttle "resize" event to every 500ms
     */
    var mq = window.matchMedia('(min-width: 1024px)'), ref;
    window.addEventListener('resize', function() {
        if (!mq.matches) return;
        clearTimeout(ref);
        ref = setTimeout(snapSubmenu, 500);
    });
})();
